export function* quotesSaga() {}
